import _reduxForm from "redux-form/es/reduxForm";
import _Field from "redux-form/es/Field";
import React from 'react';
import { ReduxFormNames } from 'swag-client-common/constants';
import Block from 'swag-client-common/components/ui/block';
import { Button, ButtonTextTransform } from 'swag-client-common/components/ui/button';
import { RectangleInput } from 'swag-client-common/components/inputs/rectangle-input';
import LoadingOverlay from 'swag-client-common/components/ui/loading-overlay';
import PasswordRequirementsBlock from 'swag-client-common/components/info/password-requirements-block';
import { required, password as passwordValidator } from 'swag-client-common/utils/redux-form-validators';
import utilClasses from 'swag-client-common/styles/utilities.scss';
import classes from './set-password-by-logged-in.scss';
const SetPasswordByLoggedIn = ({
  setFormCompletedPasswordRequirements,
  isSetFormAllPasswordRequirementsCompleted,
  isSetFormPasswordLengthMoreThanMaxAllowedCharacters,
  isSetFormPasswordInputFocused,
  isSetPasswordError,
  isSetPasswordLoading,
  isSetPasswordSuccess,
  errorMessageSetPassword,
  handleSubmit,
  onSubmit
}) => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Block, {
  className: classes.formContainer
}, /*#__PURE__*/React.createElement("form", {
  onSubmit: handleSubmit(onSubmit)
}, /*#__PURE__*/React.createElement(_Field, {
  name: "password",
  component: RectangleInput,
  className: classes.formInput,
  validate: [required, passwordValidator],
  formType: "password",
  placeholder: "Enter your new password",
  label: "New password"
}), /*#__PURE__*/React.createElement(PasswordRequirementsBlock, {
  isLengthMoreThanMaxAllowedCharacters: isSetFormPasswordLengthMoreThanMaxAllowedCharacters,
  isAllRequirementsCompleted: isSetFormAllPasswordRequirementsCompleted,
  completedRequirements: setFormCompletedPasswordRequirements,
  isInputFocused: isSetFormPasswordInputFocused
}), /*#__PURE__*/React.createElement(Button, {
  type: "primary",
  loading: isSetPasswordLoading,
  className: classes.formButton,
  formType: "submit",
  textTransform: ButtonTextTransform.none
}, "Set password"), isSetPasswordError && /*#__PURE__*/React.createElement("div", {
  className: utilClasses.error
}, errorMessageSetPassword), isSetPasswordSuccess && /*#__PURE__*/React.createElement("div", {
  className: utilClasses.success
}, "You have successfully set your password"))), /*#__PURE__*/React.createElement(LoadingOverlay, {
  isShown: isSetPasswordLoading
}));
export const SetPasswordForm = _reduxForm({
  form: ReduxFormNames.SetPasswordByLoggedInForm
})(SetPasswordByLoggedIn);